export default __webpack_public_path__ + "static/media/Celebrations9.062bcce4.png";